angular.module('ihestiaCommonDirectives.blockUi', [
  'ihestiaCommonDirectives'
  ]).run(['bodyInjectorHelper',
  function(bodyInjectorHelper) {
    bodyInjectorHelper.injectDirective('ihestiaBlockUi', 'ihestia-block-ui');
  }
]);